import { Pipe, PipeTransform } from '@angular/core';

import { isReady } from '@store';

@Pipe({
  name: 'ready',
})
export class ReadyPipe implements PipeTransform {
  transform<T>(feature: T): T {
    return isReady<T>(feature) ? feature : null;
  }
}
